/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

export enum AccountType {
  Customer = 'CUSTOMER',
  Main = 'MAIN',
  Operator = 'OPERATOR',
  ShipManager = 'SHIP_MANAGER',
  Skipper = 'SKIPPER',
  Terminal = 'TERMINAL'
}

export enum AgreementConditionType {
  ContainerFull = 'CONTAINER_FULL',
  Location = 'LOCATION',
  Product = 'PRODUCT',
  ReeferCheckType = 'REEFER_CHECK_TYPE',
  Route = 'ROUTE',
  Ship = 'SHIP',
  WaterLevel = 'WATER_LEVEL'
}

export enum AgreementTypeEnum {
  AddressCommission = 'ADDRESS_COMMISSION',
  BlockFreight = 'BLOCK_FREIGHT',
  BunkerAdjustment = 'BUNKER_ADJUSTMENT',
  Cleaning = 'CLEANING',
  Commission = 'COMMISSION',
  Daily = 'DAILY',
  DangerousGood = 'DANGEROUS_GOOD',
  Deadfreight = 'DEADFREIGHT',
  Demurrage = 'DEMURRAGE',
  DemurrageCalculation = 'DEMURRAGE_CALCULATION',
  Feet = 'FEET',
  Freight = 'FREIGHT',
  Gasoline = 'GASOLINE',
  GasolinePrice = 'GASOLINE_PRICE',
  HoseRental = 'HOSE_RENTAL',
  Hourly = 'HOURLY',
  Lumpsum = 'LUMPSUM',
  MultiCargoAdjustment = 'MULTI_CARGO_ADJUSTMENT',
  MultiOrderAdjustment = 'MULTI_ORDER_ADJUSTMENT',
  NitrogenPurging = 'NITROGEN_PURGING',
  Oog = 'OOG',
  Pjk = 'PJK',
  PostCalculation = 'POST_CALCULATION',
  Reefer = 'REEFER',
  Rent = 'RENT',
  ReturnFreightDiscount = 'RETURN_FREIGHT_DISCOUNT',
  Ship = 'SHIP',
  SupplementaryHeating = 'SUPPLEMENTARY_HEATING',
  Teu = 'TEU',
  Text = 'TEXT',
  Waterway = 'WATERWAY',
  WaterLevel = 'WATER_LEVEL',
  Weight = 'WEIGHT',
  WeightRange = 'WEIGHT_RANGE'
}

export enum AvailabilityEnum {
  Day = 'DAY',
  DayAndNight = 'DAY_AND_NIGHT',
  Night = 'NIGHT'
}

export enum AvailabilityExceptionType {
  Availability = 'AVAILABILITY',
  Exception = 'EXCEPTION'
}

export enum BargeType {
  BulkCarrier = 'BULK_CARRIER',
  ContainerShip = 'CONTAINER_SHIP',
  DryCargo = 'DRY_CARGO',
  Hopper = 'HOPPER',
  PushedBarge = 'PUSHED_BARGE',
  PusherTug = 'PUSHER_TUG',
  SemiHopper = 'SEMI_HOPPER',
  Tanker = 'TANKER'
}

export enum CalculationMethodType {
  CargoQuantity = 'CARGO_QUANTITY',
  CoveredByFreightPrice = 'COVERED_BY_FREIGHT_PRICE',
  Demurrage = 'DEMURRAGE',
  DemurrageCalculation = 'DEMURRAGE_CALCULATION',
  GasoilConsumption = 'GASOIL_CONSUMPTION',
  Lumpsum = 'LUMPSUM',
  Manual = 'MANUAL',
  PercentageOnAgreements = 'PERCENTAGE_ON_AGREEMENTS',
  QuantityUnit = 'QUANTITY_UNIT',
  ReferenceRate = 'REFERENCE_RATE',
  Staffel = 'STAFFEL',
  Tiered = 'TIERED',
  TimeUnit = 'TIME_UNIT'
}

export enum CallTimeField {
  Ata = 'ATA',
  Atd = 'ATD',
  Ateo = 'ATEO',
  Atso = 'ATSO',
  Eta = 'ETA',
  Etd = 'ETD',
  Eteo = 'ETEO',
  Etso = 'ETSO',
  Pta = 'PTA',
  StartPortChargeCountingTime = 'START_PORT_CHARGE_COUNTING_TIME',
  StartPortChargeCountingTimeOperator = 'START_PORT_CHARGE_COUNTING_TIME_OPERATOR'
}

export enum CallType {
  Cleaning = 'CLEANING',
  Discharging = 'DISCHARGING',
  Loading = 'LOADING',
  LoadingDischarging = 'LOADING_DISCHARGING',
  NitrogenPurging = 'NITROGEN_PURGING'
}

export enum CargoActionDocumentStatus {
  AllDocumentsProcessed = 'ALL_DOCUMENTS_PROCESSED',
  NewDocumentsCreated = 'NEW_DOCUMENTS_CREATED',
  NoDocumentsCreated = 'NO_DOCUMENTS_CREATED'
}

export enum CargoQuantityUnit {
  M3 = 'M3',
  Mton = 'MTON'
}

export enum ChangeType {
  Delete = 'DELETE',
  Insert = 'INSERT',
  Update = 'UPDATE'
}

export enum CharterPdfType {
  CancellationToCustomer = 'CANCELLATION_TO_CUSTOMER',
  CargoDocuments = 'CARGO_DOCUMENTS',
  NominationToCustomer = 'NOMINATION_TO_CUSTOMER',
  NominationToShipOwner = 'NOMINATION_TO_SHIP_OWNER',
  NominationToSkipper = 'NOMINATION_TO_SKIPPER'
}

export enum CharterSubtype {
  Contract = 'CONTRACT',
  Spot = 'SPOT',
  Supplier = 'SUPPLIER',
  Time = 'TIME'
}

export enum CharterType {
  Purchase = 'PURCHASE',
  Sales = 'SALES'
}

export enum CommentEntityType {
  Call = 'CALL',
  Cargo = 'CARGO',
  Contract = 'CONTRACT'
}

export enum ConnectingType {
  Barge = 'BARGE',
  Deepsea = 'DEEPSEA',
  Shortsea = 'SHORTSEA',
  Train = 'TRAIN'
}

export enum ConnectingVisitStatus {
  Arrived = 'ARRIVED',
  Cancelled = 'CANCELLED',
  Departed = 'DEPARTED',
  PreArrived = 'PRE_ARRIVED'
}

export enum Constraint {
  CurrentlyActive = 'CURRENTLY_ACTIVE',
  HasEta = 'HAS_ETA',
  IgnoreClosed = 'IGNORE_CLOSED',
  InFuture = 'IN_FUTURE',
  NotArrived = 'NOT_ARRIVED',
  NotDeparted = 'NOT_DEPARTED',
  NotFinished = 'NOT_FINISHED',
  NotPlanned = 'NOT_PLANNED',
  OnlyAccepted = 'ONLY_ACCEPTED'
}

export enum ContactRoleType {
  CargoDocuments = 'CARGO_DOCUMENTS',
  CustomerUpdate = 'CUSTOMER_UPDATE',
  DemurrageApproval = 'DEMURRAGE_APPROVAL',
  Invoice = 'INVOICE',
  InvoiceReminder = 'INVOICE_REMINDER',
  NominationAndConfirmation = 'NOMINATION_AND_CONFIRMATION',
  OrderEntry = 'ORDER_ENTRY'
}

export enum ContractStatus {
  Accepted = 'ACCEPTED',
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Finished = 'FINISHED',
  Inactive = 'INACTIVE',
  InNegotiation = 'IN_NEGOTIATION',
  Quoted = 'QUOTED',
  Rejected = 'REJECTED'
}

export enum CoreLogType {
  In = 'IN',
  Out = 'OUT'
}

export enum CraneType {
  Bulk = 'BULK',
  Container = 'CONTAINER'
}

export enum DeclarationAutoCreationCondition {
  AllCargosCancelled = 'ALL_CARGOS_CANCELLED',
  AllCargosDischarged = 'ALL_CARGOS_DISCHARGED',
  AllCargosLoaded = 'ALL_CARGOS_LOADED'
}

export enum DeclarationMonthTerm {
  CalendarMonth = 'CALENDAR_MONTH',
  Month = 'MONTH'
}

export enum DemurrageCalculationPeriodRegime {
  Sshex = 'SSHEX',
  Sshinc = 'SSHINC'
}

export enum DemurrageCalculationRoundingRule {
  Down = 'DOWN',
  Nearest = 'NEAREST',
  None = 'NONE',
  Up = 'UP'
}

export enum DemurrageCalculationRoundingScope {
  TotalAllActions = 'TOTAL_ALL_ACTIONS',
  TotalPerActionType = 'TOTAL_PER_ACTION_TYPE'
}

export enum DemurrageCalculationRoundingUnit {
  Hour = 'HOUR',
  Quarter = 'QUARTER'
}

export enum DemurrageCalculationUnit {
  DayProRata = 'DAY_PRO_RATA',
  Hour = 'HOUR'
}

export enum DemurrageCountingType {
  ShortNotice = 'SHORT_NOTICE',
  StartCountingTime = 'START_COUNTING_TIME',
  WorkingDaysSinceNomination = 'WORKING_DAYS_SINCE_NOMINATION',
  WorkingHoursSinceNomination = 'WORKING_HOURS_SINCE_NOMINATION'
}

export enum DemurragePayableOver {
  Deadweight = 'DEADWEIGHT',
  LoadedQuantity = 'LOADED_QUANTITY'
}

export enum DemurrageTerms {
  PerContract = 'PER_CONTRACT',
  Ttb2010 = 'TTB2010'
}

export enum DocumentEntity {
  Call = 'CALL',
  Cargo = 'CARGO',
  CargoAndCall = 'CARGO_AND_CALL',
  Charter = 'CHARTER',
  Contract = 'CONTRACT',
  DischargingCargo = 'DISCHARGING_CARGO',
  Invoice = 'INVOICE',
  LoadingCargo = 'LOADING_CARGO',
  Location = 'LOCATION',
  Manual = 'MANUAL',
  NitrogenPurging = 'NITROGEN_PURGING',
  Product = 'PRODUCT',
  Ship = 'SHIP',
  TankCleaning = 'TANK_CLEANING',
  Voyage = 'VOYAGE'
}

export enum DocumentStatus {
  Created = 'CREATED',
  Processed = 'PROCESSED',
  Published = 'PUBLISHED'
}

export enum DocumentTarget {
  Terminal = 'TERMINAL'
}

export enum DocumentType {
  Certificate = 'CERTIFICATE',
  CustomerTransport = 'CUSTOMER_TRANSPORT',
  Insurance = 'INSURANCE',
  Map = 'MAP',
  Other = 'OTHER',
  Sds = 'SDS',
  TonnageCertificate = 'TONNAGE_CERTIFICATE'
}

export enum EmailNotificationType {
  AlternativeEmail = 'ALTERNATIVE_EMAIL',
  None = 'NONE',
  PrimaryAndAlternativeEmail = 'PRIMARY_AND_ALTERNATIVE_EMAIL',
  PrimaryEmail = 'PRIMARY_EMAIL'
}

export enum FavoriteType {
  AgreementType = 'AGREEMENT_TYPE',
  Location = 'LOCATION',
  Product = 'PRODUCT',
  Relation = 'RELATION'
}

export enum FuelType {
  B30 = 'B30',
  Diesel = 'DIESEL',
  Gas = 'GAS'
}

export enum GasoilConsumptionPriceSource {
  Kbn = 'KBN',
  Manual = 'MANUAL'
}

export enum GasoilPriceSource {
  Core = 'CORE',
  System = 'SYSTEM',
  User = 'USER'
}

export enum HistoryEntity {
  Agreement = 'AGREEMENT',
  AgreementCondition = 'AGREEMENT_CONDITION',
  CalculationMethod = 'CALCULATION_METHOD',
  Call = 'CALL',
  Cargo = 'CARGO',
  CargoAction = 'CARGO_ACTION',
  Contract = 'CONTRACT',
  Declaration = 'DECLARATION',
  InvoiceLine = 'INVOICE_LINE',
  Tier = 'TIER'
}

export enum HistoryValueKind {
  Boolean = 'BOOLEAN',
  Collection = 'COLLECTION',
  Date = 'DATE',
  Described = 'DESCRIBED',
  Entity = 'ENTITY',
  Enum = 'ENUM',
  Instant = 'INSTANT',
  Number = 'NUMBER',
  Price = 'PRICE',
  Raw = 'RAW',
  String = 'STRING',
  TimeWindow = 'TIME_WINDOW'
}

export enum InactivityType {
  Idle = 'IDLE',
  TradingDecision = 'TRADING_DECISION',
  Wharf = 'WHARF'
}

export enum IndexationType {
  CpiPercentage = 'CPI_PERCENTAGE',
  FixedAmount = 'FIXED_AMOUNT',
  FixedPercentage = 'FIXED_PERCENTAGE',
  None = 'NONE'
}

export enum KeelClearanceStatus {
  Green = 'GREEN',
  Orange = 'ORANGE',
  Red = 'RED',
  Unknown = 'UNKNOWN'
}

export enum LabelType {
  Comment = 'COMMENT',
  Contract = 'CONTRACT',
  Message = 'MESSAGE',
  SailingReport = 'SAILING_REPORT'
}

export enum LaytimeCountingEvent {
  Custom = 'CUSTOM',
  StartLaycan = 'START_LAYCAN',
  Status = 'STATUS'
}

export enum LimitType {
  DewPoint = 'DEW_POINT',
  OxygenLevelPercentage = 'OXYGEN_LEVEL_PERCENTAGE',
  OxygenLevelPpm = 'OXYGEN_LEVEL_PPM'
}

export enum LocationAvailabilityType {
  CraneAvailability = 'CRANE_AVAILABILITY',
  MooringAvailability = 'MOORING_AVAILABILITY',
  TerminalTransferAvailability = 'TERMINAL_TRANSFER_AVAILABILITY'
}

export enum LocationType {
  Address = 'ADDRESS',
  Area = 'AREA',
  BorderCrossing = 'BORDER_CROSSING',
  BunkerStation = 'BUNKER_STATION',
  Buoy = 'BUOY',
  Depot = 'DEPOT',
  ExtractionMachine = 'EXTRACTION_MACHINE',
  InlandTerminal = 'INLAND_TERMINAL',
  NotificationArea = 'NOTIFICATION_AREA',
  Port = 'PORT',
  ScopeIn = 'SCOPE_IN',
  ScopeOut = 'SCOPE_OUT',
  Sluice = 'SLUICE',
  Terminal = 'TERMINAL',
  WaitingArea = 'WAITING_AREA',
  Warehouse = 'WAREHOUSE',
  Waterway = 'WATERWAY',
  Wharf = 'WHARF'
}

export enum LocationUserType {
  Owner = 'OWNER',
  User = 'USER'
}

export enum LockStatus {
  Blocked = 'BLOCKED',
  EnteringDownstream = 'ENTERING_DOWNSTREAM',
  EnteringUpstream = 'ENTERING_UPSTREAM',
  ExitingDownstream = 'EXITING_DOWNSTREAM',
  ExitingUpstream = 'EXITING_UPSTREAM',
  FreePassage = 'FREE_PASSAGE',
  LockingDownstream = 'LOCKING_DOWNSTREAM',
  LockingUpstream = 'LOCKING_UPSTREAM',
  OperationStandby = 'OPERATION_STANDBY',
  PreparingDownstream = 'PREPARING_DOWNSTREAM',
  PreparingUpstream = 'PREPARING_UPSTREAM',
  Unknown = 'UNKNOWN'
}

export enum MappingType {
  Reefer = 'REEFER',
  Uncategorized = 'UNCATEGORIZED'
}

export enum ModalityType {
  Barge = 'BARGE',
  SeaShip = 'SEA_SHIP',
  Train = 'TRAIN',
  Truck = 'TRUCK'
}

export enum MooringSide {
  Port = 'PORT',
  Starboard = 'STARBOARD'
}

export enum NavigationUrlParameter {
  Customer = 'CUSTOMER',
  Operator = 'OPERATOR',
  Ship = 'SHIP'
}

export enum NoticePeriod {
  AtOnce = 'AT_ONCE',
  Days_1 = 'DAYS_1',
  Months_1 = 'MONTHS_1',
  Months_2 = 'MONTHS_2',
  Months_3 = 'MONTHS_3',
  Months_6 = 'MONTHS_6',
  Weeks_1 = 'WEEKS_1',
  Years_1 = 'YEARS_1'
}

export enum NullHandling {
  Native = 'NATIVE',
  NullsFirst = 'NULLS_FIRST',
  NullsLast = 'NULLS_LAST'
}

export enum OpeningHoursType {
  Location = 'LOCATION',
  Relation = 'RELATION',
  Ship = 'SHIP'
}

export enum PjkTariff {
  Average = 'AVERAGE',
  High = 'HIGH',
  Low = 'LOW'
}

export enum PayableOver {
  Actual = 'ACTUAL',
  Nominated = 'NOMINATED',
  Preagreed = 'PREAGREED'
}

export enum Permission {
  Administrator = 'ADMINISTRATOR',
  Customer = 'CUSTOMER',
  Finance = 'FINANCE',
  FinanceAdministrator = 'FINANCE_ADMINISTRATOR',
  Main = 'MAIN',
  MainUserLimited = 'MAIN_USER_LIMITED',
  Masterdata = 'MASTERDATA',
  Operator = 'OPERATOR',
  ShipManager = 'SHIP_MANAGER',
  Skipper = 'SKIPPER',
  Terminal = 'TERMINAL'
}

export enum PjkProduct {
  Gasoil = 'GASOIL',
  Gasoline = 'GASOLINE'
}

export enum PlanningCheckSeverity {
  Error = 'ERROR',
  Warning = 'WARNING'
}

export enum PlanningCheckType {
  Angler = 'ANGLER',
  Availability = 'AVAILABILITY',
  Capacity = 'CAPACITY',
  Dimensions = 'DIMENSIONS'
}

export enum ProcessDocumentAction {
  Extract = 'EXTRACT',
  Merge = 'MERGE'
}

export enum ProductAdnCargoTankDesignId {
  ClosedCargoTank = 'CLOSED_CARGO_TANK',
  OpenCargoTank = 'OPEN_CARGO_TANK',
  OpenCargoTankWithFlameArrester = 'OPEN_CARGO_TANK_WITH_FLAME_ARRESTER',
  PressureCargoTank = 'PRESSURE_CARGO_TANK'
}

export enum ProductAdnCargoTankEquipmentId {
  CargoHeatingSystemOnBoard = 'CARGO_HEATING_SYSTEM_ON_BOARD',
  PossibilityOfCargoHeating = 'POSSIBILITY_OF_CARGO_HEATING',
  RefrigerationSystem = 'REFRIGERATION_SYSTEM',
  WaterSpraySystem = 'WATER_SPRAY_SYSTEM'
}

export enum ProductAdnCargoTankTypeId {
  CargoTankWithWallsDistinctFromOuterHull = 'CARGO_TANK_WITH_WALLS_DISTINCT_FROM_OUTER_HULL',
  IndependentCargoTank = 'INDEPENDENT_CARGO_TANK',
  IntegralCargoTank = 'INTEGRAL_CARGO_TANK',
  MembraneTank = 'MEMBRANE_TANK'
}

export enum ProductAdnClassId {
  Class_1 = 'CLASS_1',
  Class_2 = 'CLASS_2',
  Class_3 = 'CLASS_3',
  Class_4_1 = 'CLASS_4_1',
  Class_4_2 = 'CLASS_4_2',
  Class_4_3 = 'CLASS_4_3',
  Class_5_1 = 'CLASS_5_1',
  Class_5_2 = 'CLASS_5_2',
  Class_6_1 = 'CLASS_6_1',
  Class_6_2 = 'CLASS_6_2',
  Class_7 = 'CLASS_7',
  Class_8 = 'CLASS_8',
  Class_9 = 'CLASS_9'
}

export enum ProductAdnClassificationCodeId {
  ClassificationCodeClass_2A = 'CLASSIFICATION_CODE_CLASS_2_A'
}

export enum ProductAdnPackingGroupId {
  HighDanger = 'HIGH_DANGER',
  LowDanger = 'LOW_DANGER',
  MediumDanger = 'MEDIUM_DANGER'
}

export enum ProductAdnRequiredEquipmentId {
  BreathingApparatus = 'BREATHING_APPARATUS',
  EscapeDevicePp = 'ESCAPE_DEVICE_PP',
  GasDetector = 'GAS_DETECTOR',
  PersonalProtectionGear = 'PERSONAL_PROTECTION_GEAR',
  Toximeter = 'TOXIMETER'
}

export enum ProductAdnSamplingTypeId {
  Closed = 'CLOSED',
  Open = 'OPEN',
  PartlyClosed = 'PARTLY_CLOSED'
}

export enum ProductAdnTankerTypeId {
  Chemical = 'CHEMICAL',
  Gas = 'GAS',
  Normal = 'NORMAL'
}

export enum ProductAdnTemperatureClassId {
  T1 = 'T1',
  T2 = 'T2',
  T3 = 'T3',
  T4 = 'T4',
  T5 = 'T5',
  T6 = 'T6'
}

export enum QuantityUnit {
  Custom = 'CUSTOM',
  DangerousGood = 'DANGEROUS_GOOD',
  Oog = 'OOG',
  Reefer = 'REEFER',
  Teu = 'TEU'
}

export enum RechargeBillingComment {
  DeadFreight = 'DEAD_FREIGHT',
  OldVoyage = 'OLD_VOYAGE'
}

export enum RechargeBillingState {
  Billed = 'BILLED',
  Open = 'OPEN'
}

export enum ReeferCheckType {
  Economy = 'ECONOMY',
  No = 'NO',
  Plugin = 'PLUGIN',
  Premium = 'PREMIUM'
}

export enum ReferenceAdjustmentType {
  Flatprice = 'FLATPRICE',
  Percentage = 'PERCENTAGE'
}

export enum ReferenceRateBase {
  DischargeLocation = 'DISCHARGE_LOCATION',
  LoadLocation = 'LOAD_LOCATION',
  Route = 'ROUTE'
}

export enum ReferenceRateDateType {
  ActualDay = 'ACTUAL_DAY',
  AveragePrevMonth = 'AVERAGE_PREV_MONTH',
  AveragePrevQuarter = 'AVERAGE_PREV_QUARTER',
  BlDate = 'BL_DATE',
  FirstDayOfMonth = 'FIRST_DAY_OF_MONTH',
  FirstDayPrevMonth = 'FIRST_DAY_PREV_MONTH',
  LastDayPrevMonth = 'LAST_DAY_PREV_MONTH',
  Nomination = 'NOMINATION'
}

export enum ReferenceRateUnit {
  GasolinePrice = 'GASOLINE_PRICE',
  Pjk = 'PJK',
  SpotBarge = 'SPOT_BARGE'
}

export enum RelationType {
  Agent = 'AGENT',
  ApplicationRelation = 'APPLICATION_RELATION',
  Broker = 'BROKER',
  Consignor = 'CONSIGNOR',
  ContainerOperator = 'CONTAINER_OPERATOR',
  Customer = 'CUSTOMER',
  LocationRelation = 'LOCATION_RELATION',
  Operator = 'OPERATOR',
  ShippingCompany = 'SHIPPING_COMPANY',
  ShipManager = 'SHIP_MANAGER',
  Skipper = 'SKIPPER',
  Supplier = 'SUPPLIER',
  Surveyor = 'SURVEYOR'
}

export enum ReorderErrorType {
  BeforeCompletedCall = 'BEFORE_COMPLETED_CALL',
  CannotEditCompletedCall = 'CANNOT_EDIT_COMPLETED_CALL',
  CleaningBeforeDischarging = 'CLEANING_BEFORE_DISCHARGING',
  DischargingBeforeLoading = 'DISCHARGING_BEFORE_LOADING',
  DischargingHasNoLoading = 'DISCHARGING_HAS_NO_LOADING',
  MismatchingLocation = 'MISMATCHING_LOCATION',
  PurgingAfterLoading = 'PURGING_AFTER_LOADING'
}

export enum SailingReportStatus {
  Approved = 'APPROVED',
  Submitted = 'SUBMITTED'
}

export enum SalesCharterStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Draft = 'DRAFT',
  ExecutionCompleted = 'EXECUTION_COMPLETED',
  InProgress = 'IN_PROGRESS',
  Planned = 'PLANNED'
}

export enum Scheduler {
  ActiveFleet = 'ACTIVE_FLEET',
  Call = 'CALL',
  CallExpected = 'CALL_EXPECTED',
  CallLaLoList = 'CALL_LA_LO_LIST',
  Cargo = 'CARGO',
  Contract = 'CONTRACT',
  Currency = 'CURRENCY',
  DataCleanup = 'DATA_CLEANUP',
  DocumentExpire = 'DOCUMENT_EXPIRE',
  LocationCacheSync = 'LOCATION_CACHE_SYNC',
  NotificationQueue = 'NOTIFICATION_QUEUE',
  RentDeclaration = 'RENT_DECLARATION',
  ScopeIn = 'SCOPE_IN',
  SluiceSync = 'SLUICE_SYNC',
  TerminalSync = 'TERMINAL_SYNC',
  Voyage = 'VOYAGE'
}

export enum SendDocumentType {
  ReleaseNotice = 'RELEASE_NOTICE'
}

export enum ShipEventType {
  Invalid = 'INVALID',
  LoadDischarge = 'LOAD_DISCHARGE',
  Resting = 'RESTING',
  Sailing = 'SAILING',
  Waiting = 'WAITING'
}

export enum ShipNominationPeriodRegime {
  Sshex = 'SSHEX',
  Sshinc = 'SSHINC'
}

export enum ShipNominationStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Nominated = 'NOMINATED',
  NotNominated = 'NOT_NOMINATED',
  Rejected = 'REJECTED'
}

export enum ShipPositionSource {
  Actual = 'ACTUAL',
  Log = 'LOG'
}

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum StaffelInputType {
  Feet = 'FEET',
  Gasoline = 'GASOLINE',
  WaterLevel = 'WATER_LEVEL'
}

export enum StaffelUnit {
  Feet = 'FEET',
  Gasoline = 'GASOLINE',
  WaterLevel = 'WATER_LEVEL'
}

export enum StatusActualTimeType {
  Ata = 'ATA',
  Atd = 'ATD',
  Ateo = 'ATEO',
  Atn = 'ATN',
  Atso = 'ATSO',
  Dtn = 'DTN',
  Nomination = 'NOMINATION',
  NotRequired = 'NOT_REQUIRED',
  Override = 'OVERRIDE',
  RequiredForSkipper = 'REQUIRED_FOR_SKIPPER'
}

export enum StatusEstimateRequirement {
  Optional = 'OPTIONAL',
  Required = 'REQUIRED'
}

export enum StatusEstimateType {
  Eta = 'ETA',
  Etd = 'ETD',
  Eteo = 'ETEO',
  Etso = 'ETSO',
  StatusChange = 'STATUS_CHANGE'
}

export enum StatusRule {
  AllCallsVoyage = 'ALL_CALLS_VOYAGE',
  AllCargosCleaningCall = 'ALL_CARGOS_CLEANING_CALL',
  AllCargosDischargingCall = 'ALL_CARGOS_DISCHARGING_CALL',
  AllCargosFromVoyage = 'ALL_CARGOS_FROM_VOYAGE',
  AllCargosLoadingCall = 'ALL_CARGOS_LOADING_CALL',
  AllCargosNitrogenPurgingCall = 'ALL_CARGOS_NITROGEN_PURGING_CALL',
  AllDeclarationsInvoice = 'ALL_DECLARATIONS_INVOICE',
  AllVoyagesOfCargo = 'ALL_VOYAGES_OF_CARGO',
  CallCleaningCargos = 'CALL_CLEANING_CARGOS',
  CallDischargingCargos = 'CALL_DISCHARGING_CARGOS',
  CallLoadingCargos = 'CALL_LOADING_CARGOS',
  CallNextCall = 'CALL_NEXT_CALL',
  CallNitrogenPurgingCargos = 'CALL_NITROGEN_PURGING_CARGOS',
  CallOpenFollowingCalls = 'CALL_OPEN_FOLLOWING_CALLS',
  CallOpenPreviousCalls = 'CALL_OPEN_PREVIOUS_CALLS',
  FirstCallVoyage = 'FIRST_CALL_VOYAGE',
  FirstCargoCleaningCall = 'FIRST_CARGO_CLEANING_CALL',
  FirstCargoDischargingCall = 'FIRST_CARGO_DISCHARGING_CALL',
  FirstCargoLoadingCall = 'FIRST_CARGO_LOADING_CALL',
  FirstCargoNitrogenPurgingCall = 'FIRST_CARGO_NITROGEN_PURGING_CALL',
  InvoiceDeclarations = 'INVOICE_DECLARATIONS',
  VoyageCalls = 'VOYAGE_CALLS',
  VoyageCargos = 'VOYAGE_CARGOS'
}

export enum StatusType {
  Call = 'CALL',
  Cargo = 'CARGO',
  Charter = 'CHARTER',
  Declaration = 'DECLARATION',
  Invoice = 'INVOICE',
  Voyage = 'VOYAGE'
}

export enum TankCladdingType {
  Coating = 'COATING',
  MildSteel = 'MILD_STEEL',
  StainlessSteel = 'STAINLESS_STEEL'
}

export enum TankConfiguration {
  CenterTanks = 'CENTER_TANKS',
  PortStarboardTanks = 'PORT_STARBOARD_TANKS'
}

export enum TankNumberingScheme {
  Mirrored = 'MIRRORED',
  Sequential = 'SEQUENTIAL'
}

export enum TankPosition {
  Center = 'CENTER',
  Port = 'PORT',
  Starboard = 'STARBOARD'
}

export enum TierPriceUnit {
  Lumpsum = 'LUMPSUM',
  MinimumQuantityPayable = 'MINIMUM_QUANTITY_PAYABLE',
  PerUnit = 'PER_UNIT',
  SurchargePercentage = 'SURCHARGE_PERCENTAGE',
  VesselDraftInMeters = 'VESSEL_DRAFT_IN_METERS'
}

export enum TierUnit {
  CargoQuantity = 'CARGO_QUANTITY',
  GasoilPrice = 'GASOIL_PRICE',
  WaterLevel = 'WATER_LEVEL'
}

export enum TimeUnit {
  Day = 'DAY',
  DayProRata = 'DAY_PRO_RATA',
  Hour = 'HOUR',
  Month = 'MONTH',
  Week = 'WEEK'
}

export enum TransactionType {
  Both = 'BOTH',
  None = 'NONE',
  Purchase = 'PURCHASE',
  Sales = 'SALES'
}

export enum TransportType {
  Continental = 'CONTINENTAL',
  Domestic = 'DOMESTIC',
  Export = 'EXPORT',
  Import = 'IMPORT',
  Storage = 'STORAGE',
  Transhipment = 'TRANSHIPMENT'
}

export enum VatCodeType {
  Exclusive = 'EXCLUSIVE',
  Inclusive = 'INCLUSIVE',
  None = 'NONE'
}

export enum VatRelation {
  BothInsideEu = 'BOTH_INSIDE_EU',
  BothInNation = 'BOTH_IN_NATION',
  CreditorUnknown = 'CREDITOR_UNKNOWN',
  DebtorUnknown = 'DEBTOR_UNKNOWN',
  None = 'NONE',
  World = 'WORLD'
}

export enum VesselType {
  Barge = 'BARGE',
  SeaShip = 'SEA_SHIP'
}

export enum VolumeCorrectionConversionMethod {
  AstmTable_54A = 'ASTM_TABLE_54_A',
  AstmTable_54B = 'ASTM_TABLE_54_B',
  AstmTable_54D = 'ASTM_TABLE_54_D',
  DensityCorrectionFactor = 'DENSITY_CORRECTION_FACTOR'
}

export enum VolumeUnit {
  L15 = 'L15',
  L20 = 'L20',
  M3 = 'M3'
}

export enum VoyageEventType {
  Bridge = 'BRIDGE',
  Call = 'CALL',
  Lock = 'LOCK',
  MeasuringPoint = 'MEASURING_POINT',
  Shipping = 'SHIPPING',
  StartPosition = 'START_POSITION',
  Unknown = 'UNKNOWN',
  Waiting = 'WAITING'
}

export enum WeightOptionType {
  PercentageLess = 'PERCENTAGE_LESS',
  PercentageMore = 'PERCENTAGE_MORE',
  PercentageMoreOrLess = 'PERCENTAGE_MORE_OR_LESS'
}

export enum WeightToleranceType {
  CharterersOption = 'CHARTERERS_OPTION',
  MaxAcap = 'MAX_ACAP',
  MinAcap = 'MIN_ACAP',
  MinMax = 'MIN_MAX',
  OwnersOption = 'OWNERS_OPTION'
}

export enum WeightUnit {
  KgAir = 'KG_AIR',
  KgVacuum = 'KG_VACUUM',
  Mton = 'MTON'
}
